import { cn } from '../../lib/cn';
import { Button } from '../ui/button';

export interface PaginationProps {
  /** Aktuelle Seite, ab 1. */
  page: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

// Am Handy (unter 768 px) Knöpfe in voller Bedienhöhe statt `sm`.
const knopf = 'max-md:h-control-md max-md:px-3.5 max-md:text-sm';

/**
 * Seitenwechsel unter einer Liste. Am Rechner „Seite 2 von 7“ links, Zurück
 * und Weiter rechts; am Handy Zurück · Seite 2 von 7 · Weiter mit großen
 * Tippflächen. (Ergänzung, ersetzt Seitenwahl im CRM.)
 */
export function Pagination({ page, pageCount, onPageChange }: PaginationProps) {
  if (pageCount < 1) return null;
  return (
    <nav aria-label="Seiten" className="mt-3 flex items-center gap-2">
      <div aria-live="polite" className="order-2 flex-1 text-center t-small text-muted-foreground md:order-1 md:text-left">
        Seite {page} von {pageCount}
      </div>
      <Button size="sm" disabled={page <= 1} onClick={() => onPageChange(page - 1)} className={cn('order-1 md:order-2', knopf)}>
        Zurück
      </Button>
      <Button size="sm" disabled={page >= pageCount} onClick={() => onPageChange(page + 1)} className={cn('order-3', knopf)}>
        Weiter
      </Button>
    </nav>
  );
}
